import { SignIn } from "@react-gcc-eds/core";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useUserActions } from "../../actions/user-actions";
import { useStore } from "../../store";
import {
  deleteUnauthorizedUrl,
  getPersistedUnauthorizedUrl
} from "../../utils/local-storage/authorization";
import { useRedirectionHelpers } from "../../components/shared/redirection-helpers";

const LoggedIn = () => {
  const [state] = useStore();
  const navigate = useNavigate();
  const { getUser } = useUserActions();
  const { getRedirectToViewUrl } = useRedirectionHelpers();

  const fakeUser = { firstName: "", lastName: "" };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    const tmo = setTimeout(() => {
      const redirectUrl = getPersistedUnauthorizedUrl() || getRedirectToViewUrl() || "/";
      deleteUnauthorizedUrl();
      navigate(redirectUrl, { replace: true });
    }, 1000);

    return () => clearTimeout(tmo);
  }, [state.user]);

  return (
    <SignIn productName="Ericsson Customer Order Dashboard" signedInUser={state.user || fakeUser} />
  );
};

export default LoggedIn;
